export default __webpack_public_path__ + "static/media/IMG_20230720_075112_493.d48a28b5.jpg";